import { Injectable, TemplateRef } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts: any[] = [];

  show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    this.toasts.push({ textOrTpl, ...options });
  }

  clear() {
    this.toasts = [];
  }

  remove(toast: any) {
    this.toasts.splice(this.toasts.indexOf(toast), 1);
  }
}
